import { useState, useEffect } from 'react';

const convertToMilliseconds = (time: number, unit: TimeUnit) => {
  switch (unit) {
    case TimeUnit.Hours:
      return time * 3600 * 1000;
    case TimeUnit.Minutes:
      return time * 60 * 1000;
    case TimeUnit.Seconds:
      return time * 1000;
    case TimeUnit.Milliseconds:
    default:
      return time;
  }
};

// Define an enum for supported time units
export enum TimeUnit {
  Milliseconds = 'milliseconds',
  Seconds = 'seconds',
  Minutes = 'minutes',
  Hours = 'hours',
}

// Assuming TimeUnit enum and convertToMilliseconds function are defined above

const useTimer = (
  initialTime: number,
  unit: TimeUnit = TimeUnit.Milliseconds,
  interval = 1000, // Ensure this is intended to be in milliseconds
) => {
  const [time, setTime] = useState(convertToMilliseconds(initialTime, unit));
  const [isDone, setIsDone] = useState(false);

  useEffect(() => {
    const internalInterval = setInterval(() => {
      setTime((prevTime) => {
        const nextTime = prevTime - interval;
        if (nextTime <= 0) {
          clearInterval(internalInterval);
          setIsDone(true);
          return 0;
        }
        return nextTime;
      });
    }, interval);

    return () => clearInterval(internalInterval);
  }, [interval, time]);

  return {
    initialTime: convertToMilliseconds(initialTime, unit),
    time,
    isDone,
  };
};

export default useTimer;
